<!--
    字体属性编辑窗口
    作用：提供字体、字号选择等下拉的菜单组件；
    实现：下拉菜单；
    组件：el-dropdown，对应dropData.js，familyData，fontSizeData
    注释：WJ
-->
<template>
    <div
        :style="`left: ${newLeft}px;top: ${newTop}px;`"
        class="operation-font">
        <div class="operation-box">
            <div class="row-one">
                <div class="drop-box">
                    <p class="name-box family">
                        <span class="name">{{form.familySelect}}</span>
                        <img crossOrigin="anonymous" class="img angle" :src="$images.operation.sanjiaoxing" alt="" />
                    </p>
                    <DropSelect
                            :form.sync="familyData"
                            @onDropSelect="onDropSelectFamily"
                    />
                </div>
                <div class="drop-box font-size">
                    <p class="name-box">
                        <span class="name">{{form.fontSize}}</span>
                        <img crossOrigin="anonymous" class="img angle" :src="$images.operation.sanjiaoxing" alt=""  />
                    </p>
                    <DropSelect
                            :form.sync="fontSizeData"
                            @onDropSelect="onDropSelectFontSize"
                    />
                </div>
                <p class="box"
                   @click="add">
                    <img
                        crossOrigin="anonymous"
                        class="img ajia"
                        :src="$images.operation.ajia"
                        alt="ico"
                    />
                </p>
                <p class="box"
                   @click="sub">
                    <img
                        crossOrigin="anonymous"
                        class="img ajian"
                        :src="$images.operation.ajian"
                        alt="ico"
                    />
                </p>
                <p class="box">
                    <img crossOrigin="anonymous" class="img ayanse" :src="$images.operation.ayanse" alt="ico" />
                    <span class="color" :style="`background-color: ${form.fontColor} !important;`"></span>
                    <colorPicker class="yanse-box" v-model="form.fontColor" />
                </p>
                <!--p class="box">
                    <img crossOrigin="anonymous" class="img youqi" :src="$images.operation.youqi" alt="ico" />
                    <span class="color2" :style="`border-top-color: ${form.backgroundColor} !important;`"></span>
                    <colorPicker class="yanse-box" v-model="form.backgroundColor" />
                </p>
                <p class="box">
                    <img crossOrigin="anonymous" class="img ayidong" :src="$images.operation.ayidong" alt="ico" />
                </p-->
            </div>
            <div class="row-two">
                <p class="box" @click="change('b')" :class="{'active': form.b}">
                    <img crossOrigin="anonymous" class="img b" :src="$images.operation.b" alt="ico" />
                </p>
                <p class="box" @click="change('i')" :class="{'active': form.i}">
                    <img crossOrigin="anonymous" class="img xieti" :src="$images.operation.xieti" alt="ico" />
                </p>
                <p class="box" @click="change('u')" :class="{'active': form.u}">
                    <img crossOrigin="anonymous" class="img u" :src="$images.operation.u" alt="ico" />
                </p>
                <p class="box" @click="change('s')" :class="{'active': form.s}">
                    <img crossOrigin="anonymous" class="img s" :src="$images.operation.s" alt="ico" />
                </p>
                <p class="box" @click="changeAlign('left')" :class="{'active': `${form.horizontalAlign}` === '0'}">
                    <img crossOrigin="anonymous" class="img zuoduiqi" :src="$images.operation.zuoduiqi" alt="ico" />
                </p>
                <p class="box" @click="changeAlign('center')" :class="{'active': `${form.horizontalAlign}` === '1'}">
                    <img crossOrigin="anonymous" class="img juzhong" :src="$images.operation.juzhong" alt="ico" />
                </p>
                <p class="box" @click="changeAlign('right')" :class="{'active': `${form.horizontalAlign}` === '2'}">
                    <img crossOrigin="anonymous" class="img youduiqi" :src="$images.operation.youduiqi" alt="ico" />
                </p>
                <div class="drop-box">
                    <p class="name-box">
                        <img crossOrigin="anonymous" class="img jianjuduiqi" :src="$images.operation.jianjuduiqi" alt="ico" />
                        <img crossOrigin="anonymous" class="img angle" :src="$images.operation.sanjiaoxing" alt="" />
                    </p>
                    <DropSelect
                            :form.sync="shangxiaData"
                            @onDropSelect="onDropSelectShangxia"
                    />
                </div>
                <!--<div class="drop-box">-->
                    <!--<p class="name-box">-->
                        <!--<img class="img liangbianduiqi" :src="$images.operation.liangbianduiqi" alt="ico" />-->
                        <!--<img class="img angle" :src="$images.operation.sanjiaoxing" alt="" />-->
                    <!--</p>-->
                    <!--<DropSelect-->
                            <!--:form.sync="zuoyouData"-->
                            <!--@onDropSelect="onDropSelectZuoyou"-->
                    <!--/>-->
                <!--</div>-->
                <!--p class="box" @click="change('clear')" :class="{'active': form.clear}">
                    <img crossOrigin="anonymous" class="img xiangpicha" :src="$images.operation.xiangpicha" alt="ico" />
                </p-->
            </div>
        </div>
        <div class="row-three" v-if="form.isText">
            <p
                class="input"
                :class="{
                    b:form.b,
                    i:form.i,
                    u:form.u
                }"
                contenteditable="true"
            >
                {{form.text}}
                <input class="txt" type="text" v-model="form.text" />
            </p>
        </div>
    </div>
</template>

<script>
    import DropSelect from './components/dropSelect'
    import {familyData, fontSizeData, shangxiaData ,zuoyouData} from "./dropData";

    export default {
        name: "operation-font",
        components: {
            DropSelect
        },
        props: {
            top: Number,
            left: Number,
            defaultValue: Object
        },
        watch:{
            top(vl){this.newTop = vl},
            newTop(vl){this.$emit('update:top',vl)},
            left(vl){this.newLeft = vl},
            newLeft(vl){this.$emit('update:left',vl)},
            defaultValue:{
                handler(vl, old) {
                    if(JSON.stringify(vl)!==JSON.stringify(old)) {
                        this.form = {
                            ...this.form,
                            ...vl
                        }
                    }
                },
                deep: true,
                immediate: true
            },
            form:{
                handler(vl){
                    this.$emit('onOperationFont', vl)

                    let value = vl.text
                    if(this.form.b) value = `<b>${value}</b>`
                    if(this.form.i) value = `<i>${value}</i>`
                    if(this.form.u) value = `<u>${value}</u>`
                    this.form.html = value
                },
                deep:true,
                immediate: true
            }
        },
        data(){
            return {
                newTop: this.top,
                newLeft: this.left,
                form: {
                    isText: false,
                    familySelect: '方正黑体简体', // 字体选择
                    fontSize: '12', // 字体大小
                    add: 0,
                    sub: 0,
                    fontColor: '#000000', // 字体颜色
                    backgroundColor: '#000000', // 背景颜色
                    move: [0,0],
                    b: false,
                    i: false,
                    u: false,
                    s: false,
                    align: '',
                    horizontalAlign: '',
                    shangxia: '', // 上下间距
                    zouyou: '', // 左右间距
                    clear: false,
                    text: '',
                    html: ''
                },

                familyData,
                fontSizeData,
                shangxiaData,
                zuoyouData
            }
        },
        methods: {
            add (){
                let size = parseInt(this.form.fontSize) + 10
                if(size >= 200) {
                    size = 200
                }
                this.form.fontSize = `${size}`
            },
            sub () {
                let size = parseInt(this.form.fontSize) - 10
                if(size <= 0) {
                    size = 0
                }
                this.form.fontSize = `${size}`
            },
            onDropSelectFamily(value){
                this.form.familySelect = value
            },
            onDropSelectFontSize(value){
                this.form.fontSize = value
            },
            onDropSelectShangxia(value){
                this.form.shangxia = value
            },
            onDropSelectZuoyou(value){
                this.form.zouyou = value
            },
            change(type){
                this.form[type] = !this.form[type]
            },
            changeAlign(type){
                // if(this.form.align === type){
                //     this.form.align = ''
                //     return false
                // }
                // this.form.align = type
                switch (type) {
                    case 'left':
                        this.form.horizontalAlign = 0
                        break
                    case 'center':
                        this.form.horizontalAlign = 1
                        break
                    case 'right':
                        this.form.horizontalAlign = 2
                        break
                    default:
                }
            }
        }
    }
</script>
<style>
.yanse-box .colorBtn{
  width: 100% !important;
  height: 100% !important;
  opacity: 0;
}
</style>
<style lang="scss" scoped>
.operation-font{
    user-select: none;
    /*width:320px;*/
    /*height:54px;*/
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 300;
    transition: all .2s linear;

    .operation-box{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 2px 0px rgba(0, 0, 0, 0.13);
        border-radius:3px;
        padding: 10px;
    }

    .img{
        width: 16px;
        height: 16px;
        object-fit: contain;

        &.angle{
            width: 9px;
            height: 8px;
            margin-left: 8px;
        }

        &.ajia{
            width: 14px;
            height: 16px;
        }

        &.ajian{
            width: 10px;
            height: 12px;
        }

        &.ayanse{
            width: 11px;
            height: 14px;
        }

        &.youqi{
            width: 14px;
            height: 11px;
        }

        &.ayidong{
            width: 16px;
            height: 17px;
        }

        &.b{
            width: 10px;
            height: 12px;
        }

        &.xieti{
            width: 8px;
            height: 12px;
        }

        &.u{
            width: 10px;
            height: 16px;
        }

        &.s{
            width: 13px;
            height: 12px;
        }

        &.zuoduiqi,
        &.juzhong,
        &.youduiqi{
            width: 17px;
            height: 15px;
        }

        &.jianjuduiqi,
        &.liangbianduiqi{
            width: 17px;
            height: 14px;
        }

        &.xiangpicha{
            width: 14px;
            height: 11px;
        }
    }
    .box{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 2px;
        cursor: pointer;
        border: 1px solid white;
        width: 26px;
        height: 26px;
        position: relative;

        &:hover{
            border: 1px solid #f1f1f1;
            border-radius: 6px;
        }
        &:active, &.active{
            border-radius: 6px;
            background-color: #f1f1f1;
        }

        .yanse-box{
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            z-index: 301;
        }
        .color{
            position: absolute;
            bottom: 6px;
            left: 8px;
            width: 12px;
            height: 2px;
            background-color: #000000;
            border-radius: 2px;
        }
        .color2{
            position: absolute;
            bottom: 9px;
            left: 10px;
            width: 0px;
            height: 0px;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 3px solid #000000;
        }
    }
    .row-one{
        margin-bottom: 10px;

        .box{
            margin-right: 0px;
        }
    }
    .row-one, .row-two{
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .drop-box{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 2px 0px rgba(0, 0, 0, 0.13);
        border-radius:3px;
        padding: 4px 8px;
        margin-right: 10px;
        cursor: pointer;
        position: relative;

        &.font-size{
            margin-right: 4px;
        }

        .name-box{
            display: flex;
            flex-direction: row;
            align-items: center;

            .name{
                font-size: 12px;
            }

            &.family{
                .name{
                    width: 72px;
                }
            }
        }
    }

    .row-three{
        position: absolute;
        top: 100px;
        left: 0px;
        border: 2px dotted #1ce4ff;
        padding: 6px 10px;
        border-radius: 10px;

        .input{
            min-width: 357px;
            outline: none;
            position: relative;
            line-height: 20px;
            letter-spacing: 1px;

            .txt{
                position: absolute;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
                background-color: transparent;
                font-size: 1px;
                line-height: 20px;
                letter-spacing: 1px;
                border: none;
                outline: none;
                color: transparent;
            }
        }

        .i{
            font-style: italic;
        }
        .b{
            font-weight: bold;
        }
        .u{
            text-decoration: underline;
        }
    }
}
</style>
